<template>
    <div>
        <div
            :key="upload.instanceId"
            v-for="upload in uploading"
            class="d-flex align-items-center my-2"
        >
            <div class="mr-2">
                <img height="100" width="100" :src="upload.url" />
            </div>

            <div v-if="hasError(upload)">
                <b-alert variant="danger" show class="small">
                    <b-btn
                        variant="danger"
                        @click="removeErrorByInstanceId(upload.instanceId)"
                        pill
                        size="sm"
                    >
                        <font-awesome-icon size="lg" icon="fa-light fa-times" />
                        Remove
                    </b-btn>
                    {{ hasError(upload).message }}
                </b-alert>
            </div>
            <div v-else>
                <div class="d-flex align-items-center">
                    <b-spinner class="mr-2" variant="light" />
                    Uploading
                </div>
            </div>
        </div>

        <div v-if="cordova">
            <!-- !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
                 CAPACITOR MIGRATION: IF YOU ARE READING THIS AND THE APP
                 HAS BEEN MIGRATED FROM CORDOVA TO CAPACITOR, THIS v-if
                 IS A TEMPORARY PATCH AND MUST BE REMOVED. cordova-plugin-camera
                 v4 silently fails on Android due to FileProvider/intent changes
                 in Android 7+. Capacitor handles this correctly. Remove the
                 v-if="!isAndroid" and also clean up isAndroid in system.js.
                 !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! -->
            <b-btn
                v-if="!isAndroid"
                @click="launchCameraUpload"
                variant="light"
                class="d-flex align-items-center justify-content-between"
                pill
                size="lg"
                block
            >
                <div>
                    <font-awesome-icon icon="fa-duotone fa-camera" />
                </div>
                <div>Camera</div>
                <div>
                    <font-awesome-icon icon="fa-duotone fa-camera" class="invisible" />
                </div>
            </b-btn>
            <b-btn
                @click="launchFileUpload"
                variant="light"
                class="d-flex align-items-center justify-content-between"
                pill
                size="lg"
                block
            >
                <div>
                    <font-awesome-icon icon="fa-duotone fa-photo-film" />
                </div>
                <div>Gallery</div>
                <div>
                    <font-awesome-icon icon="fa-duotone fa-photo-film" class="invisible" />
                </div>
            </b-btn>
        </div>
        <div v-else>
            <universal-uploader
                @uploadSuccess="uploadPhotoSuccess"
                class="text-truncate"
            >
                <b-btn pill variant="light" size="lg" block>
                    <span class="text-primary">
                        <font-awesome-icon
                            class="mr-1"
                            icon="fa-duotone fa-image-polaroid-user"
                        />
                    </span>
                    Upload New Photo
                </b-btn>
            </universal-uploader>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

import axios from "axios";

import { PHOTO_UPLOAD_READY } from "@/constant/photoUploadEvents";

import PhotoUploadingMixin from "@/mixin/PhotoUploadingMixin";
import UniversalUploader from "@/components/universalUploader/UniversalUploader";

export default {
    mixins: [PhotoUploadingMixin],
    data() {
        return {
            uploading: [],
        };
    },
    created() {
        this.$on(PHOTO_UPLOAD_READY, this.photoUploadReady);
    },
    beforeDestroy() {
        this.$off(PHOTO_UPLOAD_READY, this.photoUploadReady);
    },
    computed: {
        ...mapState("profile", ["profile"]),
        ...mapState("conversationMedia", ["errors"]),
        ...mapState("system", ["cordova", "isAndroid"]),
    },
    methods: {
        removeErrorByInstanceId(instanceId) {
            this.$store.commit(
                "conversationMedia/removeErrorByInstanceId",
                instanceId
            );

            this.uploading = this.uploading.filter(
                (uploading) => uploading.instanceId !== instanceId
            );
        },
        hasError(upload) {
            return this.errors.find(
                (error) => error.instanceId === upload.instanceId
            );
        },
        launchCameraUpload() {
            this.cordovaPhotoUpload("camera");
        },
        launchFileUpload() {
            this.cordovaPhotoUpload("gallery");
        },
        photoUploadReady({ file, instanceId } = {}) {
            this.uploadByFile({ file, instanceId });
        },
        uploadByFile({ file, instanceId } = {}) {
            const url = URL.createObjectURL(file);
            this.uploading.push({ url, instanceId });

            const formData = new FormData();
            formData.append("file", file);
            formData.append("upload_preset", "w9g8lnht");

            axios
                .post(
                    "https://api.cloudinary.com/v1_1/findmateapp/image/upload",
                    formData
                )
                .then((response) => {
                    if (response?.data?.url) {
                        this.uploading = this.uploading.filter(
                            (u) => u.instanceId !== instanceId
                        );
                        this.uploadPhotoSuccess(response.data.url);
                    }
                })
                .catch(() => {
                    this.$store.commit("conversationMedia/appendError", {
                        instanceId,
                        message: this.$t("Photo upload failed"),
                    });
                });
        },
        uploadPhotoSuccess(url) {
            const instanceId = this.$uuid();

            this.uploading.push({ url, instanceId });

            this.api
                .post("/messagePhoto/upload", { url })
                .then(() => {
                    this.uploading = this.uploading.filter(
                        (uploading) => uploading.instanceId !== instanceId
                    );

                    this.$store.dispatch("conversationMedia/refresh");
                })
                .catch((error) => {
                    if (error?.response?.data?.message) {
                        this.$store.commit("conversationMedia/appendError", {
                            instanceId,
                            message: error?.response?.data?.message,
                        });
                    }
                });
        },
    },
    components: {
        UniversalUploader,
    },
};
</script>
